const getInitialsFromParts = (forename = null, surname = null) => {
  return `${forename ? forename.substring(0, 1) : ""}${surname ? surname.substring(0, 1) : ""}`
}

export default getInitialsFromParts